import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem("ks_token");
    const savedUser = localStorage.getItem("ks_user");
    if (savedToken && savedUser) {
      try {
        const payload = JSON.parse(atob(savedToken.split(".")[1]));
        if (payload.exp * 1000 > Date.now()) {
          setToken(savedToken);
          setUser(JSON.parse(savedUser));
        } else {
          localStorage.removeItem("ks_token");
          localStorage.removeItem("ks_user");
        }
      } catch {
        localStorage.removeItem("ks_token");
        localStorage.removeItem("ks_user");
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
    localStorage.setItem("ks_token", userToken);
    localStorage.setItem("ks_user", JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("ks_token");
    localStorage.removeItem("ks_user");
  };

  return (
    <AuthContext.Provider
      value={{ user, token, login, logout, loading, isLoggedIn: !!user }}
    >
      {children}
    </AuthContext.Provider>
  );
};
